<template>
    <div class='content'>
        <h3>
            {{ $t('dashboard.fournisseur.reglement.title') }}
            <ReglePastille cle="dashboardFournisseur.derniersReglements" />
        </h3>

        <div class='items-container' v-for='reglement in reglements' :key='reglement.id'>
            <div class='reglement border-radius item' @click='goToReglement(reglement.id)'>
                <span>{{formattedDate(reglement.dateReglement)}}</span>
                {{ $t('dashboard.fournisseur.reglement.montant') }}
                <span>{{formattedMontant(reglement.montantTTC)}}</span> {{transformeDevise(reglement.devise)}}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ReglementDTO } from '@/models/ReglementDTO';
import dayjs from 'dayjs';
import router from '@/router';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'WidgetReglement',
    components: { ReglePastille },
    data() {
        return {

        };
    },
    computed: {
        reglements(): ReglementDTO[] {
            return this.$store.getters['dashboardFournisseurState/getDerniersReglements'];
        },
    },
    methods: {
        transformeDevise(devise: string) {
            return this.$t('devise.'+ devise);
        },
        formattedDate(date: string): string{
            return dayjs(date).format('DD/MM/YYYY');
        },
        formattedMontant(montant: number): string {
            return montant.toLocaleString('fr-FR');
        },
        goToReglement(id: number) {
            router.push({ name: 'reglementFournisseurPage', params: { id: id } });
        }
    }
});
</script>

<style scoped>
.content {
    background-color: white;
    padding: 10px 30px 30px;
    height: 44vh;
    box-shadow: 5px 4px 5px 0 rgba(0, 0, 0, 0.1);
    border-radius: 20px;
}
@media (max-height: 630px) {
    .content {
        height: 68vh;
    }
}
@media screen and (max-width: 900px) and (max-height: 700px) {
    .content {
        height: 100% !important;
        padding: unset;
    }
}
.reglement {
    background-color: #75a9f9;
    cursor: pointer;
}
.border-radius {
    border-radius: 7px;
}
.items-container {
    display: flex;
    flex-wrap: wrap;
    height: 17%;
}
.item {
    width: 100%;
    margin: 10px;
    color: white;
    align-content: center;
    padding-left: 20px;
}
@media (max-width: 984px) {
    .content {
        height: 68vh;
    }
}
@media (max-width: 1195px) {
    .content {
        height: 68vh;
    }
}
</style>
